import { Observable } from 'rxjs';
import {
  GlobalDashboardQuery,
  GlobalDashboardSummary,
} from '@app/domain/models/global-dashboard.model';

/**
 * Port de lectura del Dashboard Global ("Todo").
 *
 * Una sola responsabilidad: devolver el resumen agregado multi-línea de negocio
 * para el período dado. Implementaciones remota/mock se inyectan vía
 * `GLOBAL_DASHBOARD_PROVIDERS` según `environment.globalDashboardUseMocks`.
 */
export abstract class GlobalDashboardRepository {
  abstract getSummary(query: GlobalDashboardQuery): Observable<GlobalDashboardSummary>;
}
